<template>
  <div>
    <div class="modal" tabindex="-1" role="dialog" id="modal-modulo-inscritos">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-center"> <b>Estudiantes Matriculados</b> </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4> {{curso.fullname}} - {{curso.shortname}} </h4>
            <small class="text-info">Seleccione los estudiantes para desmatricular en Moodle:</small>
            <p class="text-primary" style="margin-top:0"> <small>{{msg}}</small> </p>

            <div class="table-responsive">
              <!-- <button class="btn btn-link btn-sm" @click="selcheck(true)"> <span class="glyphicon glyphicon-check"></span> Todos</button>
              <button class="btn btn-link btn-sm" @click="selcheck(false)"> <span class="glyphicon glyphicon-unchecked"></span> Ninguno</button> -->
              <input type="text" placeholder="Buscar..." v-model="filter">
              <table class="table table-striped table-condensed table-hover" id="midatatablevins">
                <thead>
                  <tr>
                    <th> <small>Nro</small> </th>
                    <th style="min-width:350px!important"> <small>Estudiante</small> </th>
                    <th> <small>Moodle</small> </th>
                    <th> <small>Estado</small> </th>
                    <th> <small>Acciones</small> </th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="ind" v-for="(e,ind) in datos">
                    <td> <small> {{ind+1}} </small> </td>
                    <!-- <td> <small> <input type="checkbox" v-model="e.check"> {{e.nombre}} </small> </td> -->
                    <td> <small> {{e.nombre}} </small> </td>
                    <td> <small> {{e.umoodle}} </small> </td>
                    <td> 
                      <div v-if="e.estado=='2'" class="loader"></div> 
                      <small v-else> {{e.estado}} </small>
                    </td>
                    <td>
                      <button class="btn btn-link btn-sm" @click="delUnito(e)" title="Des Matricular(Elimina Estudiante del programa)"> <span class="glyphicon glyphicon-remove-sign"></span> </button>
                      <button class="btn btn-link btn-sm" data-toggle="modal" data-target="#modalmoodle" @click="cambioEstadoEstudiante( e )" title="Activar/Suspender Estudiante">  <span class="glyphicon glyphicon-user"></span> </button>
                    </td>
                  </tr>
                </tbody>
              </table> 
            </div>
          </div>
          
          <Alertas 
            ref="ealertar" 
            v-bind:msgSuccess="'El cambio de estado se realizo satisfactoriamente.'"
            v-bind:msgLoading="'Aplicando...'"
          />
          <div class="modal-footer">
            <!-- <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button> -->
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div> 
    </div>

    <div>
      <modal id="modalmoodle" v-bind:obj="seleccionadox" v-on:exito="modalExito"/>
    </div>
  </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import modal from '@/components/AEstadoMoodle.vue'
import { parseJsonError } from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  props:{ modulo:{type:Object,required:true},xprograma:{type:Object,required:true} },// {pid,ccid,tag}
  data(){
    return{
      seleccionadox: {estudiante:'',xid:-1,xtitle:'X',xbody:'X',xsql:null,sede:{correos:null}},
      asunto:'Inscripcion Moodle',
      correo:'',
      timeoutHnd: 0,
      filter: null,
      activo:true,
      isLoading: false,
      estudiantes:[],
      categoria:{},
      curso:{ fullname:'',shortname:'' },
      datos:[],
      sede:{},
      msg:'',
    }
  },
  components:{ Alertas,modal },
  watch:{ 'filter':function(){ this.myFunction1(this.filter) } },
  methods:{
    parseLabel( opt ){ return opt.nombre },
    parseModulo(){
      if( this.modulo.tag ) return this.modulo.tag.modulo.nombre
      else "";
    },
    delUnito( e ){
      e.estado = 2;
      this.desmatricular( e )
    },
    submit(){
      var vue = this;
      this.datos.forEach(function(e){
        if( e.check ) {
          e.estado = 2;
          vue.desmatricular( e )
        }
      })
    },
    selcheck( estado ){
      this.datos.forEach(function(e){
        e.check = estado;
      })
    },

    desmatricular( estudiante ){
      var vue = this;
      var opt = {
        verification: 'anular',
        verificationHelp: 'Escriba "[+:verification]" para desmatricular.',
        okText:"Anular certificado",
        cancelText:"cancelar",
        backdropClose:false,
        animation: 'bounce',
        loader: true, 
        type:"hard"
      }
      var message = {
        title: 'Confirmar desmatriculacion',
        body: '<br> <b>NOTA:</b> Al desmatricular un estudiante se perderean todos su datos.'
      };
      this.$dialog.confirm(message,opt)
      .then(function( dialog ) { 
        vue.desmatricular2( estudiante,dialog );
      })
      .catch(function() { estudiante.estado = null; });
      return;    
    },
    desmatricular2( estudiante,dialog ) {
      if( this.isLoading ) return;
      var vue = this;
      vue.isLoading = true;

      var cuerpo = {
        "data":{
          "attendant":{
            "name": this.asunto,
            "mail": this.correo
          },
          "unenrollment":{
            "username": estudiante.umoodle,
            "courseId": this.modulo.tag.course_id
          }
        }
      };
      var data = JSON.stringify(cuerpo);
      var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+"unenrol-student-notification/";
      // window.console.log( "DATA> ",data,"ESTUDIANRES: ",this.estudiantes );

      var config = { method: 'post', url: url,headers: { 'Content-Type': 'application/json' }, data : data };
      window.axios(config)
        .then(function (res) {
          var data = res.data;
          // window.console.log('------------ RESPUESTA DEL SERVIDOR ------------')
          // window.console.log( ">> ",window.stringifyObject(data) )
          vue.isLoading = false;
          vue.msg = "";
          estudiante.estado = data.moodle+', '+data.mail;
          dialog.close();
        })
        .catch(function (error) {
          window.console.error(error)
          vue.isLoading = false;
          vue.msg = "";
          dialog.close();
      });
    },
    modalExito(){},
    getCorreos( idsede ){
      var sql = gql`query{ getSede(id:${idsede}){id,nombre,correos{tipo direccion}} }`
      window.console.log( "GET SEDEX: ",sql )
      this.$apollo.query({
        query: sql,
      }).then((data) => {
        this.sede  = data.data.getSede;
        window.console.log( "SEDEX: ",this.sede )
      }).catch((error) => {
        this.msg = error;
        window.console.error(error)
        this.$notify( parseJsonError( error,'getSede' ) )
      })
    },
    cambioEstadoEstudiante( ins ){
      window.console.log( "PAL MOODLE: ",window.stringifyObject(ins) )
      this.seleccionadox.xid = ins.id; 
      this.seleccionadox.estudiante = ins.nombre;
      this.seleccionadox.sede = this.sede
      this.seleccionadox.xtitle = 'Activar/Desactivar Estudiante';
      this.seleccionadox.xbody = ins.nombre;
    },
    setEstudiantes(){
      // window.console.log( "KKKKKKKKKKKKKKKKKKKKKKKKKK,", this.modulo )
      this.curso.fullname = '';
      this.curso.shortname = '';
      var cuerpo = {
        "data":{
          "id":this.modulo.idcurso
        }
      };
      var vue = this;
      var data = JSON.stringify(cuerpo);
      var url = process.env.VUE_APP_URL_NOTIFIER_ESAM+"get-course";
      // window.console.log( "DATA> ",data,"ESTUDIANRES: ",this.estudiantes );

      var config = { method: 'post', url: url,headers: { 'Content-Type': 'application/json' }, data : data };
      window.axios(config)
        .then(function (res) {
          var data = res.data.course;
          var dts = [];
          vue.datos = [];
          // window.console.log('------------ RESPUESTA DEL SERVIDOR INSCRITOS ------------')
          // window.console.log( ">> ",window.stringifyObject(data) )

          data.enrolledUsers.forEach( function(e){
            dts.push( {id:e.id,nombre:e.firstname+' '+e.lastname,umoodle:e.username,email:e.email,estado:null,check:false} );
          })

          vue.datos = dts;
          vue.isLoading = false;
          vue.curso.fullname = data.fullname;
          vue.curso.shortname = data.shortname;
          vue.msg = "";
          
        })
        .catch(function (error) {
          window.console.error(error)
          vue.isLoading = false;
          vue.msg = "";
      });
    },

    myFunction1( filtro ) {
        filtro = filtro.toUpperCase();
        var table, tr, tdd,td, i,j, txtValue;
        table = document.getElementById("midatatablevins");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
          tdd = tr[i].getElementsByTagName("td");
          for(j = 1; j< tdd.length;j++) {
            td = tdd[j];
            if (td) {
              txtValue = td.textContent;
              if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                tr[i].style.display = "";
                break;
              } else {
                tr[i].style.display = "none";
              }
            } 
          }
        }
      }
  },
  mounted(){
    var vue = this;
    window.$('#modal-modulo-inscritos').on('show.bs.modal', function () {
      vue.setEstudiantes();
    });
    var idsede = this.$store.state.CARGO.idsede;
    this.getCorreos( idsede );
  }
}
</script>